import type { SVGProps } from 'react';
const SvgSchool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    className="school_svg__icon school_svg__icon-tabler school_svg__icon-tabler-school"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <path d="M22 9 12 5 2 9l10 4zv6" />
    <path d="M6 10.6V16a6 3 0 0 0 12 0v-5.4" />
  </svg>
);
export default SvgSchool;
